"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForgotPasswordPage = void 0;
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var main_1 = require("../../reducers/slices/main");
var universal_cookie_1 = __importDefault(require("universal-cookie"));
var send_reset_password_link_1 = require("../../api/calls/user/authentication/send_reset_password_link");
var ForgotPasswordPage = function () {
    var cookie = new universal_cookie_1.default();
    var dispatch = (0, react_redux_1.useDispatch)();
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    var _a = (0, react_1.useState)(""), emailError = _a[0], setEmailError = _a[1];
    var _b = (0, react_1.useState)(""), email = _b[0], setEmail = _b[1];
    var _c = (0, react_1.useState)(false), isLoading = _c[0], setIsLoading = _c[1];
    var _d = (0, react_1.useState)(""), errorText = _d[0], setErrorText = _d[1];
    var _e = (0, react_1.useState)(""), successText = _e[0], setSuccessText = _e[1];
    (0, react_1.useEffect)(function () {
        //
    }, []);
    var validate = function () {
        var count = 0;
        setEmailError("");
        setErrorText("");
        setSuccessText("");
        if (!email) {
            count++;
            setEmailError("Please enter your email to reset your password.");
        }
        return count > 0 ? false : true;
    };
    return (react_1.default.createElement("div", { className: "flex flex-col gap-y-4 w-96 h-full justify-center" },
        react_1.default.createElement("div", { className: "text-3xl font-bold" }, "Forgot Password"),
        react_1.default.createElement("div", { className: "flex flex-col gap-y-4" },
            react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Email ", value: email, errorText: emailError, onChange: function (v) {
                    setEmail(v);
                } }),
            react_1.default.createElement("div", { className: "flex gap-1" },
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: successText, size: "medium", textColor: "text-success" }),
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: errorText, size: "medium", textColor: "text-red-500" })),
            react_1.default.createElement("div", { className: "grid" },
                react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Send Link", loading: isLoading, enabled: !isLoading, backgroundColor: "bg-primary", onClick: function () {
                        if (validate()) {
                            setIsLoading(true);
                            (0, send_reset_password_link_1.send_reset_password_link)({ email: email }).then(function (response) {
                                if (response.success) {
                                    setSuccessText(response.message);
                                    setIsLoading(response.content.is_loading);
                                }
                                else {
                                    setErrorText(response.message);
                                    setIsLoading(response.content.is_loading);
                                }
                            });
                        }
                    } }))),
        react_1.default.createElement("div", { className: " text-center" },
            react_1.default.createElement("span", { className: "hover:underline cursor-pointer text-primary", onClick: function () {
                    dispatch((0, main_1.setDrawerPage)("login"));
                    // navigate(`${rootPath}/login`);
                } }, "Back to login"))));
};
exports.ForgotPasswordPage = ForgotPasswordPage;
